import { FC, ReactNode, useLayoutEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { log } from '../utils/log';
import { LoanFormat, mapLoanFormatToUrl, parseLoanFormat } from '../../../models/LoanFormat';
import { useLoanFormat } from '../../app-store/loanFormat/useLoanFormat';
import { LOANFORMAT_ALL_OBJECT } from '../loanFormat/constants';
import { loanFormatKeyToObject } from '../loanFormat/mappers';
import { Navigate } from 'react-router-dom';

export function replaceLoanFormat(pathname: string, value: LoanFormat, replaceValue: LoanFormat) {
    return pathname.replace(new RegExp(`/${mapLoanFormatToUrl(value)}`), `/${mapLoanFormatToUrl(replaceValue)}`);
}

export const CheckLoanFormat: FC<{ children: ReactNode }> = ({ children }) => {
    const { pathname } = useLocation();
    const { loanFormat: loanFormatParam } = useParams<'loanFormat'>();
    const loanFormat = parseLoanFormat(loanFormatParam);

    const { setLoanFormat } = useLoanFormat();

    useLayoutEffect(() => {
        const loanFormatObject = loanFormatKeyToObject(loanFormat ?? LOANFORMAT_ALL_OBJECT.key);
        setLoanFormat(loanFormatObject);
    }, [loanFormat, setLoanFormat]);

    if (loanFormat === LoanFormat.eMagazines) {
        log.warning('Deprecated eMagazine LoanFormat in path URL');
        return <Navigate to={replaceLoanFormat(pathname, LoanFormat.eMagazines, LoanFormat.ePress)} replace />;
    } else {
        return <>{children}</>;
    }
};
